import React, { useEffect, useState, useRef } from 'react';
import { Header, HeaderCart, HeaderLanguage, HeaderNav, Menu } from '../Components/Header/Header';
import { Col, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { User } from 'lucide-react';
import axios from 'axios';
import config from '../config';
import { useTranslation } from 'react-i18next';

// مكون رأس الصفحة
const Headers = (props) => {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
    const location = useLocation(); // Ajouter useLocation pour écouter les changements de route

  // جلب بيانات المستخدم إذا كان مسجلاً
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      const fetchUserProfile = async () => {
        try {
          const response = await axios.get(`${config.SITE_API_URL}/user-profile`, {
            headers: { Authorization: `Bearer ${token}`,
             'x-api-key': config.SITE_API_KEY },
          });
          setUser(response.data);
        } catch (error) {
          console.error('خطأ في جلب ملف المستخدم:', error);
          localStorage.removeItem('accessToken');
          setUser(null);
        }
      };
      fetchUserProfile();
    }
  }, []);

  
// Réinitialiser le défilement au début de la page lors de la navigation
    useEffect(() => {
        window.scrollTo(0, 0); // Défilement vers le haut (0, 0)
    }, [location.pathname]); // Déclenché à chaque changement de route

  // إغلاق القائمة المنسدلة عند النقر خارجها
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // تسجيل الخروج
  const logout = () => {
    localStorage.removeItem('accessToken');
    setUser(null);
    setIsDropdownOpen(false);
  };

  // تغيير اللغة
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // تحديد اتجاه النص بناءً على اللغة
  const isRtl = i18n.language === 'ar';

  return (
    <div style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      <Header topSpace={{ md: true }} type="reverse-scroll border-b border-[#ffffff1a]">
        <HeaderNav fluid="fluid" theme="light" expand="lg" className="px-[35px] py-[0px] md:px-0">
          <Col className={`col-sm-6 col-lg-2 ${isRtl ? 'ms-auto pe-lg-0' : 'me-auto ps-lg-0'} xs:px-0`}>
            <Link aria-label="header logo" className="flex items-center" to="/">
              <Navbar.Brand className="inline-block p-0 m-0">
                <img className="default-logo" loading="lazy" src="/logo-Jaafar-Academy-V.png" alt="logo" />
                <img className="alt-logo" width="111" height="36" loading="lazy" src="/logo-Jaafar-Academy-V.png" alt="logo" />
                <img className="mobile-logo" width="111" height="36" loading="lazy" src="/logo-Jaafar-Academy-1.png" alt="logo" />
              </Navbar.Brand>
            </Link>
          </Col>
          <div className="col-auto hidden order-last md:block">
            <Navbar.Toggle className="md:ml-[10px] sm:ml-0">
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse className="col-auto px-0 justify-end">
            <Menu />
          </Navbar.Collapse>
          <Col className={`col-auto ${isRtl ? 'text-right ps-0' : 'text-right pe-0'} gap-4`}>
            {/* <SearchBar className="pr-0" /> */}
            <HeaderLanguage changeLanguage={changeLanguage} />
            <HeaderCart />
          </Col>
          {user ? (
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center space-x-2 rounded-lg p-2 text-dark transition-colors hover:bg-gray-100"
              >
                <User className="h-6 w-6" />
                <span className="hidden text-sm font-medium sm:block">{user?.name}</span>
              </button>
              <div
                className={`absolute ${isRtl ? 'left-0' : 'right-0'} mt-2 w-48 rounded-md bg-white py-1 shadow-lg transition-all duration-200 ${
                  isDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                }`}
              >
                <Link
                  to="/dashboard"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  {t('header.dashboard')}
                </Link>
                <Link
                  to="/profile"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  {t('header.profile')}
                </Link>
                <button
                  onClick={logout}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  {t('header.logout')}
                </button>
              </div>
            </div>
          ) : (
            <div className="flex items-center space-x-4 gap-4">
              <span className={`flex items-center ${isRtl ? 'pr-5' : 'pl-5'} py-[9px] text-black`}>
                <Link aria-label={t('header.register')} to="/inscription" className="flex items-center">
                  <img src="/assets/img/adduser.svg" className="h-[16px] w-[16px]" alt={t('header.register')} />
                </Link>
              </span>
              <span className="flex items-center py-[9px] text-black">
                <Link aria-label={t('header.login')} to="/login" className="flex items-center">
                  <img src="/assets/img/login.svg" className="h-[16px] w-[16px]" alt={t('header.login')} />
                </Link>
              </span>
            </div>
          )}
        </HeaderNav>
      </Header>
    </div>
  );
};

export default Headers;